import React, { useState, useEffect } from "react";
import { styled } from "@mui/material/styles";
import {
  Card,
  CardActionArea,
  CardActions,
  CardContent,
  CardMedia,
  Button,
  Typography,
  Grid,
} from "@mui/material";
import AliceCarousel from "react-alice-carousel";
import VideoCarousel from "./VideoCarousel";
import "react-alice-carousel/lib/alice-carousel.css";
import CountUp from "react-countup";
import { millify } from "millify";
import programs from "../resources/programs";
import "../../App.css";
import config from "../config.json";
import Popup from "./popup";
import { BRAND_NAME, BRAND_MEMBER, BRAND_MEMBERS } from "../../config/constants";
const PREFIX = "LandingPage";

const classes = {
  root: `${PREFIX}-root`,
  media: `${PREFIX}-media`,
  cardImage: `${PREFIX}-cardImage`,
};

const Root = styled("div")({
  [`& .${classes.root}`]: {
    maxWidth: 345,
    borderRadius: 150,
  },
  [`& .${classes.media}`]: {
    height: 200,
  },
  [`& .${classes.cardImage}`]: {
    height: 240,
  },
});

const stringifiedUser = localStorage.getItem("user");
const user = JSON.parse(stringifiedUser);

//bottom news items array common for all
const handleDragStart = (e) => e.preventDefault();
const videos = [
  {
    src: `${process.env.REACT_APP_R2_URL}/videos/WhatsApp%20Video%202025-05-09%20at%2012.44.25.mp4`,
    thumbnail: `${process.env.REACT_APP_R2_URL}/Screenshot%202025-05-09%20at%2012.59.03%E2%80%AFPM.png`,
  },
  {
    src: `${process.env.REACT_APP_R2_URL}/videos/WhatsApp%20Video%202025-05-15%20at%2021.37.03%20(1).mp4`,
  },
  {
    src: `${process.env.REACT_APP_R2_URL}/videos/WhatsApp%20Video%202025-05-15%20at%2021.37.03.mp4`,
  },
  {
    src: `${process.env.REACT_APP_R2_URL}/videos/WhatsApp%20Video%202025-05-15%20at%2021.37.04%20(1).mp4`,
  },
  {
    src: `${process.env.REACT_APP_R2_URL}/videos/WhatsApp%20Video%202025-05-15%20at%2021.37.04.mp4`,
  },
  {
    src: `${process.env.REACT_APP_R2_URL}/videos/PiQture_Me_showcase_2024_1_b77j70.mp4`,
    thumbnail: `${process.env.REACT_APP_R2_URL}/videos/Screenshot_2024-03-31_133518_cq8wck.png`,
  },
  {
    src: `${process.env.REACT_APP_R2_URL}/videos/finding_your_tribe_2024_gwayxg.mp4`,
  },
  {
    src: `${process.env.REACT_APP_R2_URL}/videos/Trash_Mafia_kids_wins_2024_pgjyby.mp4`,
  },
  {
    src: `${process.env.REACT_APP_R2_URL}/videos/Globally_good_-_Snehagram_HiV_food_funding_Jahaan_Arora_z7vmkg.mp4`,
  },
  {
    src: `${process.env.REACT_APP_R2_URL}/videos/ocialcred_Time_Banking_Paper_2024_isgbww.mp4`,
    thumbnail: `${process.env.REACT_APP_R2_URL}/videos/Screenshot_2024-03-31_133905_utoly6.png`,
  },
  {
    src: `${process.env.REACT_APP_R2_URL}/videos/1_Million_meals_fn0vqm.mp4`,
  },
  {
    src: `${process.env.REACT_APP_R2_URL}/videos/2023_Milestones_ocialCred_gaw2yg.mp4`,
  },
  {
    src: `${process.env.REACT_APP_R2_URL}/videos/Making_programs_easy_uoevcn.mp4`,
  },


  // Add more video objects
];
const items = [
  <img
    alt={""}
    style={{ width: "100%", borderRadius: 60 }}
    src={`${process.env.REACT_APP_R2_URL}/1.7.jpeg`}
    onDragStart={handleDragStart}
  />,
  <img
    alt={""}
    style={{ width: "100%", borderRadius: 60 }}
    src={`${process.env.REACT_APP_R2_URL}/1.8.jpeg`}
    onDragStart={handleDragStart}
  />,
  <img
    alt={""}
    style={{ width: "100%", borderRadius: 60 }}
    src={`${process.env.REACT_APP_R2_URL}/1.5.jpeg`}
    onDragStart={handleDragStart}
  />,
  <img
    alt={""}
    style={{ width: "100%", borderRadius: 60 }}
    src={`${process.env.REACT_APP_R2_URL}/1.1.jpeg`}
    onDragStart={handleDragStart}
  />,
  <img
    alt={""}
    style={{ width: "100%", borderRadius: 60 }}
    src={`${process.env.REACT_APP_R2_URL}/1.2.jpeg`}
    onDragStart={handleDragStart}
  />,
  <img
    alt={""}
    style={{ width: "100%", borderRadius: 60 }}
    src={`${process.env.REACT_APP_R2_URL}/1.3.jpeg`}
    onDragStart={handleDragStart}
  />,
  <img
    alt={""}
    style={{ width: "100%", borderRadius: 60 }}
    src={`${process.env.REACT_APP_R2_URL}/1.6.jpeg`}
    onDragStart={handleDragStart}
  />,
];

//array of objects from where all the data is passed
const data = {
  socialcreds: {
    highlightCards: [
      {
        title: BRAND_NAME,
        media:
          `${process.env.REACT_APP_R2_URL}/socialcred_journey_2024_gjt45m.mp4`,
        description:
          `${BRAND_NAME} aims to raise awareness in children that social giving can begin with small acts of kindness at home, within communities and encourage them to contribute in ways that make them happy. We encourage students to start their own projects, find projects they are interested in volunteering for, and amplify the results of their impacts. Our platform helps track kiddie time across projects to consolidate into one certificate.`,
        link: user ? "/dashboard" : "/signup/offer",
      },
      {
        title: "Swim for Hope",
        image:
          `${process.env.REACT_APP_R2_URL}/Screenshot%202025-05-09%20at%2012.59.03%E2%80%AFPM.png`,
        media:
          `${process.env.REACT_APP_R2_URL}/videos/WhatsApp%20Video%202025-05-09%20at%2012.44.25.mp4`,
        description:
          "Dive into impact with Swim For Hope! Led by Anoushka and supported by Inventure, 100+ kids swam 3,363 laps, raising £4,000+ to fund a year’s supply of adult diapers for Swanthana. With cheers from parents and faculty, this student-powered event is now set to become an inspiring annual tradition of giving.",
        link: "/event/596"
      },

      // {
      //   title: "Time Banking",
      //   image:
      //     `${process.env.REACT_APP_R2_URL}/videos/Screenshot_2024-03-31_133905_utoly6.png`,
      //   media:
      //     `${process.env.REACT_APP_R2_URL}/videos/ocialcred_Time_Banking_Paper_2024_isgbww.mp4`,
      //   description:
      //     "Join us on our mission to recycle 100 tonnes of dry waste, saving it from landfills and generating cash from trash. Kids in 100 communities are leading the charge as Trash Mafia champions, spearheading dry waste collection efforts. Together, let's create a cleaner, greener future!",
      //   link: user ? "/program/137" : "/signup/offer",
      //   // image: `${process.env.REACT_APP_R2_URL}/news_thumb_sc.png`,
      //   // description:
      //   //   "Introducing our latest quarterly newsletter, showcasing the remarkable achievements of our outstanding $ocialcredders! Discover inspiring stories of compassion, innovation, and empowerment as our community drives positive change in sustainability, social justice, and education. Join us on this transformative journey towards a brighter future. Happy reading!",
      //   // readMore: `${process.env.REACT_APP_R2_URL}/news_thumb_sc.png`,
      // },
      {
        title:
          "Remnant Revivals – Reduce and Reuse",
        media:
          `${process.env.REACT_APP_R2_URL}/videos/WhatsApp%20Video%202025-05-15%20at%2021.36.43.mp4`,
        description:
          "A non-profit startup committed to environmental sustainability 🌱 and women's empowerment 💗. We transform tailor scraps into stylish, reusable cloth bags while providing income opportunities for women passionate about sewing. Launched with a successful brainstorming session on March 30th, we’ve received funding, essential materials, and valuable mentorship from eco-conscious leaders. Together, we aim to reduce waste and uplift communities—one stitch at a time",
        link: user ? "/program/197" : "/program/197",
      }
      // {
      //   title:
      //     "One Million Meals: A Heartfelt Initiative to Combat Child Hunger",
      //   media:
      //     `${process.env.REACT_APP_R2_URL}/videos/WhatsApp%20Video%202025-05-15%20at%2021.36.43.mp4`,
      //   description:
      //     "Join us in making a difference! Our 'One Million Meals' campaign aims to provide vital sustenance to children facing hunger. Every meal matters. Together, we can alleviate hunger and nourish young minds for a brighter future. Let's spread love and compassion, one meal at a time.",
      //   link: user ? "/program/109" : "/signup/offer",
      // },
    ],
    newsItems: [
      {
        title: `${BRAND_NAME} Fair@ Netradyne Dec20`,
        description:
          `Netradyne's 450 plus employees invited ${BRAND_MEMBERS} to showcase their programs and raised over Rs 26950/-. carol sining in the offices brought Christmas cheer and then a festive lunch with the kids. The program stalls saw a lot of interest and employees participated and supported each program encouraging each child to do more! Cheer 4children rasied 1750 & PiQture me stall raised funds(1895) for 185 childhood memories, Friend a senior(800), Joy of giving(620), social lab(600), Librray creds(500), and 1 million meals raised funds for 500 kgs of rice thats 5,000 meals for 1000 orphans in Bangalore`,
        image:
          `${process.env.REACT_APP_R2_URL}/activity/jnzd8dfslcq6besbalp2.png`,
        readMore: false,
      },
      {
        title: "Cheer4Children - Navjeevan Homes",
        description:
          "Thanks for supporting the wish tree - generous contributions from APR brought a smile to the kids faces. Special Thanks to Amit and Siddharth for showing support, Swati Nigam and Ramraj for their cars, Padma for christmas gear, Sharmila for carols, Kids Tarini and Ayana for carols. Regular volunteers Aisha Sasha and vaanya. And cake volunteers - on behalf of cheer for children team - sivanka, Anisha, Viraj and their moms Namita and myself. Big thanks and merry xmas",
        image:
          `${process.env.REACT_APP_R2_URL}/general/navjeevan_christmas.jpg`,
        readMore: false,
      },
      {
        title: "Senior Caroling",
        description:
          "A massive show at Annual Open House Christmas party for Seniors in APR",
        image:
          `${process.env.REACT_APP_R2_URL}/activity/nh6waiuee9qviuthytyb.jpg`,
        readMore: false,
      },
      {
        title: "2023 TISB Emmbi SI Fistful of Grain Launch",
        description:
          "Distributing bags to TISB primary years and educating them towards the cause",
        image:
          `${process.env.REACT_APP_R2_URL}/activity/fyueubivigy8okhgi4nr.jpg`,
        readMore: false,
      },
      {
        title: "SI fistful of grains Emmbi launch @ One World international",
        description:
          "Distributing fistful of grain bags to 500 one world international students to donate food for orphans in bangalore",
        image:
          `${process.env.REACT_APP_R2_URL}/activity/krchzwpuvagcbvfxmidz.jpg`,
        readMore: false,
      },
      {
        title: "Kolar Komputers in the News!",
        description:
          "Provide speak easy english and computer training and coaching to 28 schools with over 1000 children",
        image:
          `${process.env.REACT_APP_R2_URL}/got_news.jfif`,
        readMore: false,
      },
      {
        title:
          `Industry Leaders Rally Behind ${BRAND_NAME} Team's Impactful Projects!`,
        description:
          `Our ${BRAND_NAME} team had an exciting opportunity to meet with industry leaders to pitch their impactful social cause projects! Special thanks to Mr. Vikram Arora (Egon Zehnder Partner) and Mr. Nitin Gupta (Co-Founder Finnable) for their invaluable insights and support.`,
        image:
          `${process.env.REACT_APP_R2_URL}/sc_egon_nitin_news.jfif`,
        readMore: false,
      },
      {
        title: "INTERNATIONAL TIMEBANKING DAY",
        description:
          `A couple of TISB students, Sanjana from Grade 11 and Jahaan from Grade 9, have received the opportunity to present their initiative ‘${BRAND_NAME}’ at the World Time Banking conference, which is being organised by ‘Timebanking UK’ on March 20 and 23.`,
        image:
          `${process.env.REACT_APP_R2_URL}/TISB2.PNG`,
        link: "https://www.tisb.org/news/2022-03-03/social-cred-on-international-timebanking-day",
        readMore: true,
      },
      {
        title: `${BRAND_MEMBER} Children's Day`,
        description:
          `An event for the most exciting ${BRAND_MEMBERS} where they showcase their social projects, what they are working on. A fun filled event with Pizzas, songs, dance`,
        image: `${process.env.REACT_APP_R2_URL}/activity/pkvpka9wqynukiocjzzd.jpg`,
        link: `https://www.${process.env.REACT_APP_HOST_NAME}.com/event/275`,
        readMore: true,
      },
      {
        title: "Say YES to the Joy of Giving!",
        description:
          "The Project seeks the involvment of school Children. Each child is given an eco-friendly jute bag. Everyday, they have to put in a fistful of grain in a bag. All grains collected will be donated to worthy children's shelters that need help for providing nutrition to deprived children.",
        image:
          `${process.env.REACT_APP_R2_URL}/fistful.jfif`,
        link: "https://www.tisb.org/news/2022-03-03/social-cred-on-international-timebanking-day",
        readMore: false,
      },
      {
        title: "RENT-A-CROCKERY",
        description:
          "Say YES to eco-friendly options with RENT-A-CROCKERY. Rent a set of 6 pieces for as low as Rs.10 per set. A set includes a Dinner plate, a glass, two bowls, a spoon, and a fork.",
        image:
          `${process.env.REACT_APP_R2_URL}/rent_crockery.jfif`,
        link: "https://www.tisb.org/news/2022-03-03/social-cred-on-international-timebanking-day",
        readMore: false,
      },
      {
        title: `${BRAND_NAME} IN GWH ANNUAL REPORT`,
        description:
          "Sakshi Mittal conducted awareness campaigns among students and managed to collect over 200 notebooks as well as 600 pieces of clothing to donate to underpriveleged children. This initiative was recognized in the GWH Annual report.",
        image:
          `${process.env.REACT_APP_R2_URL}/sakshi_gwh.jpg`,
        link: "https://www.tisb.org/news/2022-03-03/social-cred-on-international-timebanking-day",
        readMore: false,
      },
      {
        title: "PY ENVIRONMENTAL PROJECT",
        description:
          "In the PY Assembly on March 20, Environmental Prefect Darnita from Grade 5 and Jahaan from Grade 9 presented a plan to encourage students to get involved in raising clothes, notebooks, toys and trash for different organisations, and to reduce global warming for a better environment. ",
        image:
          `${process.env.REACT_APP_R2_URL}/TISB.png`,
        link: "https://www.tisb.org/news/2022-05-27/py-environmental-project",
        readMore: true,
      },
    ],
  },
  giftoftime: {
    highlightCards: [
      {
        title: "Trash Mafia",
        image:
          `${process.env.REACT_APP_R2_URL}/trash.jpeg`,
        description:
          "We collect your dry waste for absolute 0 charge and raise funds for our ecowarriors programs : an urban forest, transgender rehabilitation and much more",
        link: user ? "/dashboard" : "/signup/offer",
      },
      {
        title: "Speak Easy English",
        image:
          `${process.env.REACT_APP_R2_URL}/pspeakeasy.jpeg`,
        description:
          "Teach conversational English to an underpriviledged child for 30 minutes twice a week.",
        link: user ? "/dashboard" : "/signup/offer",
      },
    ],
    newsItems: [
      {
        title: `${BRAND_NAME} Fair@ Netradyne Dec20`,
        description:
          `Netradyne's 450 plus employees invited ${BRAND_MEMBERS} to showcase their programs and raised over Rs 26950/-. carol sining in the offices brought Christmas cheer and then a festive lunch with the kids. The program stalls saw a lot of interest and employees participated and supported each program encouraging each child to do more! Cheer 4children rasied 1750 & PiQture me stall raised funds(1895) for 185 childhood memories, Friend a senior(800), Joy of giving(620), social lab(600), Librray creds(500), and 1 million meals raised funds for 500 kgs of rice thats 5,000 meals for 1000 orphans in Bangalore`,
        image:
          `${process.env.REACT_APP_R2_URL}/activity/jnzd8dfslcq6besbalp2.png`,
        readMore: false,
      },
      {
        title: "Cheer4Children - Navjeevan Homes",
        description:
          "Thanks for supporting the wish tree - generous contributions from APR brought a smile to the kids faces. Special Thanks to Amit and Siddharth for showing support, Swati Nigam and Ramraj for their cars, Padma for christmas gear, Sharmila for carols, Kids Tarini and Ayana for carols. Regular volunteers Aisha Sasha and vaanya. And cake volunteers - on behalf of cheer for children team - sivanka, Anisha, Viraj and their moms Namita and myself. Big thanks and merry xmas",
        image:
          `${process.env.REACT_APP_R2_URL}/general/navjeevan_christmas.jpg`,
        readMore: false,
      },
      {
        title: "Senior Caroling",
        description:
          "A massive show at Annual Open House Christmas party for Seniors in APR",
        image:
          `${process.env.REACT_APP_R2_URL}/activity/nh6waiuee9qviuthytyb.jpg`,
        readMore: false,
      },
      {
        title: "2023 TISB Emmbi SI Fistful of Grain Launch",
        description:
          "Distributing bags to TISB primary years and educating them towards the cause",
        image:
          `${process.env.REACT_APP_R2_URL}/activity/fyueubivigy8okhgi4nr.jpg`,
        readMore: false,
      },
      {
        title: "SI fistful of grains Emmbi launch @ One World international",
        description:
          "Distributing fistful of grain bags to 500 one world international students to donate food for orphans in bangalore",
        image:
          `${process.env.REACT_APP_R2_URL}/activity/krchzwpuvagcbvfxmidz.jpg`,
        readMore: false,
      },
      {
        title: "Kolar Komputers in the News!",
        description:
          "Provide speak easy english and computer training and coaching to 28 schools with over 1000 children",
        image:
          `${process.env.REACT_APP_R2_URL}/got_news.jfif`,
        readMore: false,
      },
      {
        title:
          `Industry Leaders Rally Behind ${BRAND_NAME} Team's Impactful Projects!`,
        description:
          `Our ${BRAND_NAME} team had an exciting opportunity to meet with industry leaders to pitch their impactful social cause projects! Special thanks to Mr. Vikram Arora (Egon Zehnder Partner) and Mr. Nitin Gupta (Co-Founder Finnable) for their invaluable insights and support.`,
        image:
          `${process.env.REACT_APP_R2_URL}/sc_egon_nitin_news.jfif`,
        readMore: false,
      },
      {
        title: "INTERNATIONAL TIMEBANKING DAY",
        description:
          `A couple of TISB students, Sanjana from Grade 11 and Jahaan from Grade 9, have received the opportunity to present their initiative ‘${BRAND_NAME}’ at the World Time Banking conference, which is being organised by ‘Timebanking UK’ on March 20 and 23.`,
        image:
          `${process.env.REACT_APP_R2_URL}/TISB2.PNG`,
        link: "https://www.tisb.org/news/2022-03-03/social-cred-on-international-timebanking-day",
        readMore: true,
      },
      {
        title: `${BRAND_MEMBER} Children's Day`,
        description:
          `An event for the most exciting ${BRAND_MEMBERS} where they showcase their social projects, what they are working on. A fun filled event with Pizzas, songs, dance`,
        image: `${process.env.REACT_APP_R2_URL}/activity/pkvpka9wqynukiocjzzd.jpg`,
        link: `https://www.${process.env.REACT_APP_HOST_NAME}.com/event/275`,
        readMore: true,
      },
      {
        title: "Say YES to the Joy of Giving!",
        description:
          "The Project seeks the involvment of school Children. Each child is given an eco-friendly jute bag. Everyday, they have to put in a fistful of grain in a bag. All grains collected will be donated to worthy children's shelters that need help for providing nutrition to deprived children.",
        image:
          `${process.env.REACT_APP_R2_URL}/fistful.jfif`,
        link: "https://www.tisb.org/news/2022-03-03/social-cred-on-international-timebanking-day",
        readMore: false,
      },
      {
        title: "RENT-A-CROCKERY",
        description:
          "Say YES to eco-friendly options with RENT-A-CROCKERY. Rent a set of 6 pieces for as low as Rs.10 per set. A set includes a Dinner plate, a glass, two bowls, a spoon, and a fork.",
        image:
          `${process.env.REACT_APP_R2_URL}/rent_crockery.jfif`,
        link: "https://www.tisb.org/news/2022-03-03/social-cred-on-international-timebanking-day",
        readMore: false,
      },
      {
        title: `${BRAND_NAME} IN GWH ANNUAL REPORT`,
        description:
          "Sakshi Mittal conducted awareness campaigns among students and managed to collect over 200 notebooks as well as 600 pieces of clothing to donate to underpriveleged children. This initiative was recognized in the GWH Annual report.",
        image:
          `${process.env.REACT_APP_R2_URL}/sakshi_gwh.jpg`,
        link: "https://www.tisb.org/news/2022-03-03/social-cred-on-international-timebanking-day",
        readMore: false,
      },
      {
        title: "PY ENVIRONMENTAL PROJECT",
        description:
          "In the PY Assembly on March 20, Environmental Prefect Darnita from Grade 5 and Jahaan from Grade 9 presented a plan to encourage students to get involved in raising clothes, notebooks, toys and trash for different organisations, and to reduce global warming for a better environment. ",
        image:
          `${process.env.REACT_APP_R2_URL}/TISB.png`,
        link: "https://www.tisb.org/news/2022-05-27/py-environmental-project",
        readMore: true,
      },
    ],
  },
  jobcreds: {
    highlightCards: [
      {
        title: "Launch Job Cred$",
        media: `${process.env.REACT_APP_R2_URL}/jc.mp4`,
        description:
          "Gift of Time Foundation and St Aloysius College launch Job Cred$ - an explosive internship program designed to get soon to graduate students get job ready !",
        link: user ? "/dashboard" : "/signup/offer",
      },
      {
        title: "Speak Easy English",
        image:
          `${process.env.REACT_APP_R2_URL}/pspeakeasy.jpeg`,
        description:
          "Teach conversational English to an underpriviledged child for 30 minutes twice a week.",
        link: user ? "/dashboard" : "/signup/offer",
      },
    ],
    newsItems: [
      {
        image: `${process.env.REACT_APP_R2_URL}/jc1.jpeg`,
      },
      {
        image: `${process.env.REACT_APP_R2_URL}/jc2.jpeg`,
      },
      {
        image: `${process.env.REACT_APP_R2_URL}/jc3.jpeg`,
      },
      {
        image: `${process.env.REACT_APP_R2_URL}/jc4.jpeg`,
      },
    ],
  },
};

const counterFontSizes = {
  mobile: {
    number: "h6",
    title: "subtitle2",
    carousel: {
      title: "h1",
      desc: "h6",
    },
  },
  default: {
    number: "h3",
    title: "h6",
    carousel: {
      title: "h1",
      desc: "h3",
    },
  },
};

const getRandomStat = (min, max) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

function LandingPage({ isMobile }) {
  const [isLoading, setIsLoading] = useState(true);
  const [userCounts, setUserCount] = useState(() => getRandomStat(10000, 20000));
  const [programCounts, setProgramCounts] = useState(() => getRandomStat(100, 160));
  const [eventCounts, setEventCounts] = useState(() => getRandomStat(350, 450));
  const [credExchangeCounts, setCredExchangeCounts] = useState(() => getRandomStat(100000, 150000));
  const [pledged, setPledged] = useState(() => getRandomStat(1000000, 1500000));
  const [showPopup, setShowPopup] = useState(false);
  const sizes = isMobile ? counterFontSizes.mobile : counterFontSizes.default;

  const handleDownload = () => {
    const link = document.createElement("a");
    link.href = `${process.env.REACT_APP_R2_URL}/sc_newsletter.pdf`; // Replace with the actual path to your PDF file
    link.target = "_blank"; // Set the target attribute to '_blank' to open in a new tab
    link.rel = "noopener noreferrer"; // Set rel attributes for security best practices
    link.download = `${BRAND_NAME} Newsletter.pdf`; // Replace with the desired filename for the downloaded file
    link.click();
  };

  useEffect(() => {
    let isMounted = true;
    setShowPopup(false);

    // Shuffle numbers rapidly while loading so 0 0 0 0 is never shown during cold starts
    const shuffleInterval = setInterval(() => {
      if (!isMounted) return;
      setUserCount(getRandomStat(10000, 20000));
      setProgramCounts(getRandomStat(100, 160));
      setEventCounts(getRandomStat(350, 450));
      setPledged(getRandomStat(1000000, 1500000));
      setCredExchangeCounts(getRandomStat(100000, 150000));
    }, 120);

    fetch(process.env.REACT_APP_API_URL + `/api/landing/page`, {
      method: "GET",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      redirect: "follow",
      referrerPolicy: "no-referrer",
      body: JSON.stringify(),
    })
      .then((res) => res.json())
      .then((data) => {
        if (!isMounted) return;
        clearInterval(shuffleInterval);
        const stats = data.response.response_data[0];
        setUserCount(stats.Users);
        setProgramCounts(stats.Programs);
        setEventCounts(stats.Events);
        setCredExchangeCounts(stats.CredExchange);
        const realPledged = Array.isArray(stats.Pledged) ? stats.Pledged[0] : stats.Pledged;
        setPledged(realPledged);
        setIsLoading(false);
      })
      .catch((err) => {
        if (!isMounted) return;
        clearInterval(shuffleInterval);
        setIsLoading(false);
      });

    return () => {
      isMounted = false;
      clearInterval(shuffleInterval);
    };
    // eslint-disable-next-line
  }, []);

  const handleClosePopup = () => {
    setShowPopup(false);
  };

  const DisplayDesktop = () => {
    return (
      <>
        <Root>
          <Grid
            container
            style={{
              backgroundColor:
                config[process.env.REACT_APP_HOST_NAME].css.pastelWebsiteColor,
              justifyContent: "center",
              marginTop: 5,
            }}
          >
            <Grid item xs={3} sm={3} md={2}>
              <Typography variant={sizes.number} align="center">
                {isLoading ? (
                  millify(userCounts, { precision: 2 })
                ) : (
                  <CountUp
                    start={0}
                    end={userCounts}
                    duration={3}
                    formattingFn={(value) => (value ? millify(value, { precision: 2 }) : 0)}
                  />
                )}
              </Typography>
              <Typography variant={sizes.title} align="center">
                Users
              </Typography>
            </Grid>
            <Grid item xs={2} sm={3} md={2}>
              <Typography variant={sizes.number} align="center">
                {isLoading ? (
                  programCounts
                ) : (
                  <CountUp start={0} end={programCounts} duration={3} />
                )}
              </Typography>
              <Typography variant={sizes.title} align="center">
                Programs
              </Typography>
            </Grid>
            <Grid item xs={2} sm={3} md={2}>
              <Typography variant={sizes.number} align="center">
                {isLoading ? (
                  eventCounts
                ) : (
                  <CountUp start={0} end={eventCounts} duration={3} />
                )}
              </Typography>
              <Typography variant={sizes.title} align="center">
                Events
              </Typography>
            </Grid>
            <Grid item xs={2} sm={3} md={2}>
              <Typography variant={sizes.number} align="center">
                {isLoading ? (
                  millify(pledged, { precision: 2 })
                ) : (
                  <CountUp
                    start={0}
                    end={pledged}
                    duration={3}
                    formattingFn={(value) => (value ? millify(value, { precision: 2 }) : 0)}
                  />
                )}
              </Typography>
              <Typography variant={sizes.title} align="center">
                Hours pledged
              </Typography>
            </Grid>
            <Grid item xs={3} sm={3} md={2}>
              <Typography variant={sizes.number} align="center">
                {isLoading ? (
                  millify(credExchangeCounts, { precision: 2 })
                ) : (
                  <CountUp
                    start={0}
                    end={credExchangeCounts}
                    duration={3}
                    formattingFn={(value) => (value ? millify(value, { precision: 2 }) : 0)}
                  />
                )}
              </Typography>
              <Typography variant={sizes.title} align="center">
                Time cred$ exchanges
              </Typography>
            </Grid>
          </Grid>
        </Root>
        <div style={{ backgroundColor: "#ffffff", padding: "20px" }}>
          <Grid container spacing={1}>
            <Grid
              container
              style={{
                paddingBottom: "25px",
                paddingTop: "25px",
                justifyContent: "center",
                gap: "10px",
              }}
            >
              <Grid item xs={7} md={2}>
                <Button
                  href="/programs/timeline"
                  style={{
                    height: 50,
                    fontFamily: "Raleway",
                    width: "100%",
                    backgroundColor:
                      config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                    borderRadius: 30,
                    color:
                      config[process.env.REACT_APP_HOST_NAME].css
                        .buttonFontColor,
                    cursor: "pointer",
                  }}
                >
                  Recent Programs
                </Button>
              </Grid>
              <Grid item xs={5} md={2}>
                <Button
                  href="/events/timeline"
                  style={{
                    height: 50,
                    fontFamily: "Raleway",
                    width: "100%",
                    backgroundColor:
                      config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                    borderRadius: 30,
                    color:
                      config[process.env.REACT_APP_HOST_NAME].css
                        .buttonFontColor,
                  }}
                >
                  Recent events
                </Button>
              </Grid>
              <Grid item xs={5} md={2}>
                <Button
                  href="/calendar/event"
                  style={{
                    height: 50,
                    fontFamily: "Raleway",
                    width: "100%",
                    backgroundColor:
                      config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                    borderRadius: 30,
                    color:
                      config[process.env.REACT_APP_HOST_NAME].css
                        .buttonFontColor,
                  }}
                >
                  Event Calendar
                </Button>
              </Grid>
              <Grid item xs={7} md={2}>
                <Button
                  href="/human-library"
                  style={{
                    height: 50,
                    fontFamily: "Raleway",
                    width: "100%",
                    backgroundColor:
                      config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                    borderRadius: 30,
                    color:
                      config[process.env.REACT_APP_HOST_NAME].css
                        .buttonFontColor,
                    cursor: "pointer",
                  }}
                >
                  Human Library
                </Button>
              </Grid>
            </Grid>

            <Grid
              container
              style={{ fontFamily: "Raleway", justifyContent: "center" }}
            >
              {process.env.REACT_APP_HOST_NAME !== "socialcreds" && (
                <Grid item lg={1}></Grid>
              )}
              <Grid
                item
                md={4}
                xs={12}
                style={{ textAlign: window.innerWidth < 600 ? "center" : null }}
              >
                <img
                  alt={"logo"}
                  src={`${process.env.REACT_APP_R2_URL}/${process.env.REACT_APP_HOST_NAME}.jpeg`}
                  height="290px"
                  width="100%"
                  style={{ marginTop: 28 }}
                ></img>
                <h5
                  style={{
                    fontSize: 26,
                    fontFamily: "Raleway",
                    textAlign: "center",
                  }}
                >
                  Clock in your goodwill hours today!
                </h5>
                <Grid style={{ display: "flex", justifyContent: "center" }}>
                  <Button
                    href="/signup/offer"
                    style={{
                      height: 40,
                      fontFamily: "Raleway",
                      width: 100,
                      backgroundColor:
                        config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                      borderRadius: 30,
                      color:
                        config[process.env.REACT_APP_HOST_NAME].css
                          .buttonFontColor,
                    }}
                  >
                    Sign Up
                  </Button>
                  &nbsp;&nbsp;&nbsp;
                  <Button
                    href="/donate"
                    style={{
                      height: 40,
                      fontFamily: "Raleway",
                      width: 100,
                      backgroundColor:
                        config[process.env.REACT_APP_HOST_NAME].css.buttonColor,
                      borderRadius: 30,
                      color:
                        config[process.env.REACT_APP_HOST_NAME].css
                          .buttonFontColor,
                    }}
                  >
                    Donate
                  </Button>
                </Grid>
              </Grid>

              <Grid
                item
                xs={12}
                md={process.env.REACT_APP_HOST_NAME !== "socialcreds" ? 7 : 8}
              >
                <Grid item xs={12} md={12} style={{ textAlign: "center" }}>
                  <Typography
                    style={{
                      fontSize: 32,
                      fontFamily: "Raleway",
                      textAlign: "center",
                      paddingTop: "20px",
                      paddingBottom: "20px",
                    }}
                  >
                    Check out our programs below!
                  </Typography>
                </Grid>
                <Grid
                  container
                  spacing={2}
                  style={{
                    justifyContent: "center",
                    display: "flex",
                    alignItems: "stretch",
                  }}
                >
                  {data[process.env.REACT_APP_HOST_NAME].highlightCards.map(
                    (card, index) => (
                      <Grid
                        item
                        md={
                          process.env.REACT_APP_HOST_NAME !== "socialcreds"
                            ? 5
                            : 4
                        }
                        key={index}
                        style={{ paddingBottom: "15px" }}
                      >
                        <Card
                          className={classes.root}
                          style={{
                            borderRadius: 30,
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                          }}
                        >
                          <CardActionArea
                            href={card.link}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ flexGrow: 1 }}
                          >
                            {card.media && card.media.endsWith(".mp4") ? (
                              <CardMedia
                                component="video"
                                controls
                                style={{ height: 180 }}
                                poster={card.image}
                              >
                                <source src={card.media} type="video/mp4" />
                              </CardMedia>
                            ) : (
                              <CardMedia
                                className={classes.media}
                                style={{ height: 180 }}
                                image={card.image}
                              />
                            )}

                            <CardContent>
                              <Typography
                                component="h2"
                                style={{ fontSize: 20, fontFamily: "Raleway" }}
                              >
                                {card.title}
                              </Typography>
                              <br></br>
                              <Typography
                                component="h2"
                                style={{ fontSize: 14, fontFamily: "Raleway" }}
                              >
                                {card.description}
                              </Typography>
                            </CardContent>
                          </CardActionArea>
                          <div
                            style={{ marginTop: "auto", textAlign: "center" }}
                          >
                            {card.readMore ? (
                              <Typography
                                onClick={handleDownload}
                                style={{
                                  backgroundColor:
                                    config[process.env.REACT_APP_HOST_NAME].css
                                      .buttonColor,
                                  color:
                                    config[process.env.REACT_APP_HOST_NAME].css
                                      .buttonFontColor,
                                  width: "60%",
                                  margin: "auto",
                                  marginBottom: "15px",
                                  padding: "5px",
                                  display: "flex",
                                  textAlign: "center",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  cursor: "pointer",
                                  borderRadius: 50,
                                }}
                              >
                                {" "}
                                CHECK IT OUT!
                              </Typography>
                            ) : (
                              <Button
                                size="big"
                                color="primary"
                                style={{
                                  fontSize: "18px",
                                  textAlign: "center",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                  fontFamily: "Raleway",
                                  color:
                                    config[process.env.REACT_APP_HOST_NAME].css
                                      .websiteColor,
                                  borderRadius: 40,
                                  marginTop: "auto",
                                  fontWeight: "bold",
                                }}
                                href={card.link}
                              >
                                GET INVOLVED
                              </Button>
                            )}
                          </div>
                        </Card>
                      </Grid>
                    )
                  )}
                </Grid>
              </Grid>
            </Grid>
            <Grid container justifyContent="center">
              <Grid item xs={12} md={12}>
                <Typography
                  component="h1"
                  style={{
                    fontSize: 30,
                    fontFamily: "Raleway",
                    display: "flex",
                    justifyContent: "center",
                    paddingTop: "40px",
                    paddingBottom: "30px",
                  }}
                >
                  {process.env.REACT_APP_HOST_NAME === "giftoftime" ? (
                    <Grid item xs={12}>
                      <Grid container spacing={1}>
                        <Grid item xs={12}>
                          <Typography
                            style={{
                              textAlign: "center",
                              fontSize: 32,
                              fontFamily: "Raleway",
                            }}
                          >
                            Choose your way of gifting time
                          </Typography>
                          <br></br>
                        </Grid>

                        <Grid item xs={12}>
                          <Grid container style={{ justifyContent: "center" }}>
                            {programs
                              ? programs.map((info) => (
                                <Card
                                  style={{
                                    width: "100%",
                                    maxWidth: 380,
                                    marginLeft: 10,
                                    marginBottom: 20,
                                    marginRight: 10,
                                    display: "flex",
                                    flexDirection: "column",
                                    // justifyContent: "space-between",
                                  }}
                                >
                                  <CardMedia
                                    className={classes.media2}
                                    image={info.image}
                                    style={{
                                      height: 50,
                                      paddingTop: "61%",
                                    }}
                                  />
                                  <CardContent>
                                    <Typography
                                      variant="h6"
                                      style={{
                                        fontFamily: "Raleway",
                                        textAlign: "center",
                                      }}
                                    >
                                      {info.title}
                                    </Typography>
                                    <Typography
                                      variant="body2"
                                      color="textSecondary"
                                      component="p"
                                      style={{
                                        fontFamily: "Raleway",
                                        textAlign: "center",
                                      }}
                                    >
                                      {info.describe}
                                    </Typography>
                                  </CardContent>
                                  <CardActions style={{ marginTop: "auto" }}>
                                    {info.website !== "" ? (
                                      <Button href={info.website}>
                                        Visit
                                      </Button>
                                    ) : (
                                      <Button href={info.website}>
                                        Coming Soon
                                      </Button>
                                    )}
                                  </CardActions>
                                </Card>
                              ))
                              : ""}
                          </Grid>
                        </Grid>
                      </Grid>
                      <br></br>
                    </Grid>
                  ) : null}
                </Typography>
              </Grid>
              <Typography
                style={{
                  textAlign: "center",
                  fontSize: 32,
                  fontFamily: "Raleway",
                }}
              >
                Video Gallery
              </Typography>
              <Grid
                item
                xs={12}
                style={{ paddingTop: "50px" }}
                alignItems="center"
              >
                <Grid item md={12} xs={12}>
                  <VideoCarousel videos={videos} />
                </Grid>
              </Grid>
              <Grid item xs={12}>
                <Typography
                  style={{
                    textAlign: "center",
                    fontSize: 32,
                    fontFamily: "Raleway",
                  }}
                >
                  {process.env.REACT_APP_HOST_NAME === "jobcreds"
                    ? null
                    : process.env.REACT_APP_HOST_NAME === "socialcreds"
                      ? `${BRAND_NAME} in the News`
                      : "Gift Of Time Highlights"}
                </Typography>
                <br></br>
              </Grid>

              <Grid item md={12} xs={12}>
                <AliceCarousel mouseTracking autoPlay autoPlayInterval={3000}>
                  {data[process.env.REACT_APP_HOST_NAME].newsItems.map(
                    (item, index) => (
                      <Grid
                        container
                        key={index}
                        style={{ justifyContent: "center", display: "flex" }}
                        spacing={1}
                      >
                        <Grid
                          item
                          xs={12}
                          md={6}
                          style={{ justifyContent: "center", display: "flex" }}
                        >
                          <img
                            alt={""}
                            src={item.image}
                            style={{
                              width:
                                process.env.REACT_APP_HOST_NAME === "jobcreds"
                                  ? "70%"
                                  : "100%",
                              maxHeight:
                                process.env.REACT_APP_HOST_NAME === "jobcreds"
                                  ? "70vh"
                                  : "50vh",
                            }}
                          ></img>
                        </Grid>
                        <Grid
                          item
                          xs={12}
                          md={6}
                          style={{
                            justifyContent: "center",
                            display: "flex",
                            alignItems: "center",
                          }}
                        >
                          <Grid container>
                            <Grid
                              item
                              xs={12}
                              md={12}
                              style={{
                                justifyContent: "center",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                component={sizes.carousel.title}
                                style={{
                                  fontFamily: "Raleway",
                                  textAlign: "center",
                                  borderBottom: "4px solid",
                                  borderColor:
                                    config[process.env.REACT_APP_HOST_NAME].css
                                      .websiteColor,
                                }}
                              >
                                {item.title}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              md={12}
                              style={{
                                justifyContent: "center",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              <Typography
                                component={sizes.carousel.desc}
                                style={{
                                  fontFamily: "Raleway",
                                  textAlign: "center",
                                }}
                              >
                                {item.description}
                              </Typography>
                            </Grid>
                            <Grid
                              item
                              xs={12}
                              md={12}
                              style={{
                                justifyContent: "center",
                                display: "flex",
                                alignItems: "center",
                              }}
                            >
                              {item.readMore && (
                                <Button
                                  href={item.link}
                                  style={{
                                    height: 40,
                                    fontFamily: "Raleway",
                                    width: 120,
                                    backgroundColor:
                                      config[process.env.REACT_APP_HOST_NAME]
                                        .css.buttonColor,
                                    borderRadius: 30,
                                    color:
                                      config[process.env.REACT_APP_HOST_NAME]
                                        .css.buttonFontColor,
                                  }}
                                >
                                  Read More!
                                </Button>
                              )}
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    )
                  )}
                </AliceCarousel>
              </Grid>
            </Grid>

            <Grid container style={{ paddingTop: "50px" }} alignItems="center">
              <Grid item md={6} xs={12}>
                <AliceCarousel
                  mouseTracking
                  innerWidth={"100%"}
                  items={items}
                ></AliceCarousel>
              </Grid>
              <Grid item md={6} xs={12}>
                <Typography
                  style={{
                    fontFamily: "MonteCarlo",
                    textAlign: "center",
                    fontSize: 50,
                  }}
                >
                  One of the greatest gifts you can give is the gift of time. .{" "}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        </div>
      </>
    );
  };
  return (
    <>
      {showPopup && <Popup onClose={handleClosePopup} />}
      <div>{DisplayDesktop()}</div>
    </>
  );
}

export default LandingPage;
